//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'GlasgowComaScale_info',
  data () {
    return {
    }
  },
  components: {
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Pedi/GlasgowComaScale_info.vue